type TutorialVideoProps = {
  title: string;
  description: string;
  videoSrc: string;
  posterSrc: string;
  captionsSrc: string;
};

export function TutorialVideo({ title, description, videoSrc, posterSrc, captionsSrc }: TutorialVideoProps) {
  return (
    <details className="tutorial-video">
      <summary>Watch: {title}</summary>
      <div className="tutorial-video-content">
        <p className="muted">{description}</p>
        <video controls preload="none" playsInline poster={posterSrc} aria-label={title}>
          <source src={videoSrc} type="video/mp4" />
          <track kind="captions" src={captionsSrc} srcLang="en" label="English" default />
          Your browser does not support the video element.
        </video>
      </div>
    </details>
  );
}
